import { useEffect } from "react";
import "./App.css";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { BookSection } from "./components/BookSection";
import { SeriesSection } from "./components/SeriesSection";
import { ContactSection, Footer } from "./components/ContactFooter";

function App() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 300);
      }
    }
  }, []);
  return (
    <div className="App" style={{ background: '#0d0f12', minHeight: '100vh' }}>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <BookSection />
        <SeriesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
